import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const STORAGE_KEY = 'fdn_admin_token';
const META_KEY = 'fdn_admin_token_meta';
// Admin tokens live 12h to match the backend JWT
const MAX_AGE_MS = 12 * 60 * 60 * 1000;
// Auto-logout after 30 min of inactivity (sensitive admin console)
const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
const isDev = process.env.NODE_ENV === 'development';

function warn(context, err) {
  if (isDev) console.warn(`[adminTokenStorage:${context}]`, err);
}

export const adminTokenStorage = {
  get() {
    try {
      const t = localStorage.getItem(STORAGE_KEY);
      if (!t) return null;
      const meta = JSON.parse(localStorage.getItem(META_KEY) || '{}');
      if (meta.savedAt && (Date.now() - meta.savedAt) > MAX_AGE_MS) {
        this.clear();
        return null;
      }
      if (meta.lastActivity && (Date.now() - meta.lastActivity) > IDLE_TIMEOUT_MS) {
        this.clear();
        return null;
      }
      return t;
    } catch (e) {
      warn('get', e);
      return null;
    }
  },
  touch() {
    try {
      const meta = JSON.parse(localStorage.getItem(META_KEY) || '{}');
      meta.lastActivity = Date.now();
      localStorage.setItem(META_KEY, JSON.stringify(meta));
    } catch (e) {
      warn('touch', e);
    }
  },
  set(token) {
    try {
      localStorage.setItem(STORAGE_KEY, token);
      localStorage.setItem(META_KEY, JSON.stringify({ savedAt: Date.now(), lastActivity: Date.now() }));
    } catch (e) {
      warn('set', e);
    }
  },
  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(META_KEY);
    } catch (e) {
      warn('clear', e);
    }
  },
};

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const t = adminTokenStorage.get();
  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
    adminTokenStorage.touch();
  }
  return config;
});
